@if (hasBeenVisible && loadedTeams) {
  <ag-grid-angular
    style="width: 100%; min-height:400px; height: calc(100vh - 300px);"
    class="ag-theme-balham"
    [gridOptions]="gridOptions"
    [rowData]="steps"
    [columnDefs]="columnDefs">
  </ag-grid-angular>
}